import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { formatApiError } from "./api";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      style={S.page}
    >
      <form onSubmit={submit} style={S.card} data-testid="admin-login-form">
        <div style={S.brand}>Target Health</div>
        <div style={S.title}>Master Rules Console</div>
        <div style={S.subtitle}>
          Sign in with your senior-team email and password.
        </div>

        <label style={S.label}>Email</label>
        <input
          data-testid="admin-login-email"
          type="email"
          autoFocus
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={S.input}
        />

        <label style={S.label}>Password</label>
        <input
          data-testid="admin-login-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={S.input}
        />

        {err && (
          <div data-testid="admin-login-error" style={S.error}>
            {err}
          </div>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          style={{ ...S.btn, opacity: busy ? 0.6 : 1 }}
        >
          {busy ? "Signing in..." : "Sign in"}
        </button>

        <div style={S.foot}>
          Forgot your password? Ask the admin to reset it from the
          <b> Users</b> tab. Sessions last 12 hours.
        </div>
      </form>
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#0b1220 0%,#101a2e 100%)",
    color: "#e2e8f0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    fontFamily: "ui-sans-serif,system-ui,-apple-system,'Segoe UI',sans-serif",
  },
  card: {
    background: "#0f172a",
    border: "1px solid #1f2a44",
    borderRadius: 14,
    padding: 36,
    width: "100%",
    maxWidth: 380,
    boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
  },
  brand: {
    fontSize: 12,
    letterSpacing: 3,
    color: "#22d3ee",
    textTransform: "uppercase",
    marginBottom: 6,
  },
  title: { fontSize: 22, fontWeight: 700, color: "#f1f5f9" },
  subtitle: { color: "#94a3b8", fontSize: 14, marginTop: 6, marginBottom: 24 },
  label: { display: "block", fontSize: 12, color: "#94a3b8", marginTop: 10 },
  input: {
    width: "100%",
    padding: "10px 12px",
    marginTop: 4,
    background: "#0b1220",
    border: "1px solid #334155",
    borderRadius: 8,
    color: "#f1f5f9",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
  },
  error: {
    background: "rgba(220,38,38,0.12)",
    border: "1px solid rgba(220,38,38,0.5)",
    color: "#fecaca",
    padding: "8px 12px",
    borderRadius: 8,
    marginTop: 14,
    fontSize: 13,
  },
  btn: {
    marginTop: 18,
    width: "100%",
    padding: "12px 14px",
    border: "none",
    borderRadius: 10,
    background: "#10b981",
    color: "white",
    fontWeight: 700,
    fontSize: 15,
    cursor: "pointer",
  },
  foot: { marginTop: 18, fontSize: 12, color: "#64748b", lineHeight: 1.6 },
};
